import { Component } from "@angular/core"
import { App, AlertController, LoadingController, ModalController } from "ionic-angular"

import firebase from "firebase"

import { RegisterFinishPage } from "./finish"
import { LoginPage } from "../login"

@Component({
  selector: "register-page",
  templateUrl: "index.html",
})
export class RegisterPage {

  user: any = {}

  constructor(
    private appCtrl: App,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController
  ) {}

  onConfirm() {

    if (!this.user.firstName || !this.user.lastName || !this.user.email) {
      this.alertCtrl.create({
        message: "Por favor informe seu nome, sobrenome e e-mail",
        buttons: ["Ok"]
      }).present()
      return
    }

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    firebase.auth().fetchProvidersForEmail(this.user.email)
      .then((providers) => {

        loading.dismiss()

        if (providers && providers.length > 0) {

          this.alertCtrl.create({
            message: "E-mail já cadastrado",
            buttons: ["Ok"]
          }).present()

        } else {

          this.modalCtrl.create(RegisterFinishPage, { user: this.user }).present()
        }
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao verificar e-mail",
          buttons: ["Ok"]
        }).present()
      })
  }

  onBackToLogin() {

    this.appCtrl.getRootNavs()[0].setRoot(LoginPage, {}, {animate: true, direction: "back"})
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/index.ts